import React, { useContext, useEffect, useState } from 'react';
import {
    Typography,
    ListItemIcon,
    Divider,
    MenuList,
    MenuItem
} from '@material-ui/core';
import { useSelector, useDispatch } from "react-redux";

import {
    languageJson,
    features
} from 'config';
import assets from 'assets';
import { useHistory, useLocation } from "react-router-dom";
import { FirebaseContext } from 'common';
import { PanelMenu } from 'primereact/panelmenu';
import "primereact/resources/primereact.min.css";
import 'primereact/resources/themes/saga-green/theme.css';
import '../assets/css/app-accordion-menu.css';


function AppMenu() {
    const { api } = useContext(FirebaseContext);
    const languageCode = useSelector(state => state.languagedata.languageCode);
    const language = languageJson[languageCode];
    const {
        signOutUser
    } = api;
    const auth = useSelector(state => state.auth);
    const dispatch = useDispatch();
    const LogOut = () => {
        dispatch(signOutUser());
    };
    let isAdmin = auth.info && auth?.info?.profile && auth?.info?.profile.usertype === 'admin';
    const history = useHistory();
    const location = useLocation();
    const itemRoutes = {
        drivers: [
            '/drivers',
            '/drivers-work-schedule',
            '/unapprove-drivers',
            '/driversuspensions',
            '/blockeddrivers'
        ],
        passengers: [
            '/riders',
            '/guestusers',
            '/blockedriders'
        ],
        reports: [
            '/earningreports',
            '/driverearning',
            '/driverstaxes'
        ],
        wallet: [
            '/wallethistory',
            '/tcupdatewallets',
            '/addtowallet',
            '/withdraws'
        ],
        vouchers: [
            '/uservouchers',
            '/driverpromotions',
            '/passengerdiscounts'
        ],
        parameters: [
            '/parameters',
            '/rechargecommission',
            '/cartypes',
            '/zones',
            '/subzones',
            '/crowdedzones',
            '/incrementhours',
            '/cancelreasons',
            '/defaultfeedbacks',
            '/defaultchatmessages',
            '/appsliders',
            '/termsandprivacy'
        ],
        settings: [
            '/settings',
            '/fleetadmins',
            '/dispatchers-work-schedule',
            '/profile'
        ]
    };

    const isExpanded = (item) => {
        return itemRoutes[item]?.includes(location.pathname) || false;
    };

    const menuItems = [
        {
            className: location.pathname === '/dashboard-beta' ? 'p-highlight': '',
            label: language.dashboard_text,
            icon: 'pi pi-fw pi-home',
            command: () => {
                history.push("/dashboard-beta");
            },
        },
        {
            className: location.pathname === '/saved-address' ? 'p-highlight': '',
            label: language.saved_addresses,
            icon: 'pi pi-fw pi-map-marker',
            command: () => {
                history.push("/saved-address");
            },
        },
        {
            className: location.pathname === '/bookingsadvance' ? 'p-highlight': '',
            label: language.booking_history,
            icon: 'pi pi-fw pi-book',
            command: () => {
                history.push("/bookingsadvance");
            },
        },
        {
            className: location.pathname === '/incidentreports' ? 'p-highlight': '',
            label: language.incident_reports,
            icon: 'pi pi-fw pi-info-circle',
            command: () => {
                history.push("/incidentreports");
            },
        },
        {
            className: location.pathname === '/appointmentbooking' ? 'p-highlight': '',
            label: language.appointment_booking,
            icon: 'pi pi-fw pi-calendar',
            command: () => {
                history.push("/appointmentbooking");
            },
        },
        {
            label: language.drivers,
            icon: 'pi pi-fw pi-car',
            expanded: isExpanded('drivers'),
            items: [
                {
                    className: location.pathname === '/drivers' ? 'p-highlight': '',
                    label: language.drivers,
                    icon: 'pi pi-fw pi-users',
                    command: () => {
                        history.push("/drivers");
                    }
                },
                {
                    className: location.pathname === '/drivers-work-schedule' ? 'p-highlight': '',
                    label: language.work_schedule,
                    icon: 'pi pi-fw pi-calendar',
                    command: () => {
                        history.push("/drivers-work-schedule");
                    }
                },
                {
                    className: location.pathname === '/unapprove-drivers' ? 'p-highlight': '',
                    label: language.unapprove_drivers,
                    icon: 'pi pi-fw pi-times-circle',
                    command: () => {
                        history.push("/unapprove-drivers");
                    }
                },
                {
                    className: location.pathname === '/driversuspensions' ? 'p-highlight': '',
                    label: language.driver_suspensions,
                    icon: 'pi pi-fw pi-user-minus',
                    command: () => {
                        history.push("/driversuspensions");
                    }
                },
                {
                    className: location.pathname === '/blockeddrivers' ? 'p-highlight': '',
                    label: language.blocked_drivers,
                    icon: 'pi pi-fw pi-ban',
                    command: () => {
                        history.push("/blockeddrivers");
                    }
                },
            ]
        },
        {
            label: language.passengers_label,
            icon: 'pi pi-fw pi-users',
            expanded: isExpanded('passengers'),
            items: [
                {
                    className: location.pathname === '/riders' ? 'p-highlight': '',
                    label: language.passengers_label,
                    icon: 'pi pi-fw pi-users',
                    command: () => {
                        history.push("/riders");
                    }
                },
                {
                    className: location.pathname === '/guestusers' ? 'p-highlight': '',
                    label: language.guest_booking_history,
                    icon: 'pi pi-fw pi-user',
                    command: () => {
                        history.push("/guestusers");
                    }
                },
                {
                    className: location.pathname === '/blockedriders' ? 'p-highlight': '',
                    label: language.blocked_riders,
                    icon: 'pi pi-fw pi-ban',
                    command: () => {
                        history.push("/blockedriders");
                    }
                },
            ]
        },
        {
            className: location.pathname === '/chat' ? 'p-highlight': '',
            label: language.chat,
            icon: 'far fa-comments',
            command: () => {
                history.push("/chat");
            },
        },
        {
            label: language.report,
            icon: 'pi pi-fw pi-chart-pie',
            expanded: isExpanded('reports'),
            items: [
                {
                    className: location.pathname === '/earningreports' ? 'p-highlight': '',
                    label: language.earning_reports,
                    icon: 'pi pi-fw pi-dollar',
                    command: () => {
                        history.push("/earningreports");
                    }
                },
                {
                    className: location.pathname === '/driverearning' ? 'p-highlight': '',
                    label: language.driver_earning,
                    icon: 'pi pi-fw pi-dollar',
                    command: () => {
                        history.push("/driverearning");
                    }
                },
                {
                    className: location.pathname === '/driverstaxes' ? 'p-highlight': '',
                    label: language.drivers_taxes_report,
                    icon: 'pi pi-fw pi-money-bill',
                    command: () => {
                        history.push("/driverstaxes");
                    }
                },
            ]
        },
        {
            label: language.settings_label2,
            icon: 'pi pi-fw pi-wallet',
            expanded: isExpanded('wallet'),
            items: [
                {
                    className: location.pathname === '/wallethistory' ? 'p-highlight': '',
                    label: language.wallet_history,
                    icon: 'pi pi-fw pi-dollar',
                    command: () => {
                        history.push("/wallethistory");
                    }
                },
                {
                    className: location.pathname === '/tcupdatewallets' ? 'p-highlight': '',
                    label: 'TC ' + language.add_to_wallet,
                    icon: 'pi pi-fw pi-dollar',
                    command: () => {
                        history.push("/tcupdatewallets");
                    }
                },
                {
                    className: location.pathname === '/addtowallet' ? 'p-highlight': '',
                    label: language.add_to_wallet,
                    icon: 'pi pi-fw pi-dollar',
                    command: () => {
                        history.push("/addtowallet");
                    }
                },
                {
                    className: location.pathname === '/withdraws' ? 'p-highlight': '',
                    label: language.withdraws,
                    icon: 'pi pi-fw pi-dollar',
                    command: () => {
                        history.push("/withdraws");
                    }
                },
            ]
        },
        {
            label: language.vouchers,
            icon: 'pi pi-fw pi-tags',
            expanded: isExpanded('vouchers'),
            items: [
                {
                    className: location.pathname === '/uservouchers' ? 'p-highlight': '',
                    label: language.vouchers,
                    icon: 'pi pi-fw pi-tag',
                    command: () => {
                        history.push("/uservouchers");
                    }
                },
                {
                    className: location.pathname === '/driverpromotions' ? 'p-highlight': '',
                    label: language.driver_promotions,
                    icon: 'pi pi-fw pi-tag',
                    command: () => {
                        history.push("/driverpromotions");
                    }
                },
                {
                    className: location.pathname === '/passengerdiscounts' ? 'p-highlight': '',
                    label: language.passenger_discounts,
                    icon: 'pi pi-fw pi-tag',
                    command: () => {
                        history.push("/passengerdiscounts");
                    }
                },
            ]
        },
        {
            className: location.pathname === '/notifications' ? 'p-highlight': '',
            label: language.push_notification_title,
            icon: 'pi pi-pw pi-bell',
            command: () => {
                history.push("/notifications");
            },
        },
        {
            label: language.parameters,
            icon: 'pi pi-fw pi-briefcase',
            expanded: isExpanded('parameters'),
            items: [
                {
                    className: location.pathname === '/parameters' ? 'p-highlight': '',
                    label: language.parameters,
                    icon: 'pi pi-fw pi-cog',
                    command: () => {
                        history.push("/parameters");
                    }
                },
                {
                    className: location.pathname === '/referralsettings' ? 'p-highlight': '',
                    label: language.referral_settings,
                    icon: 'pi pi-fw pi-cog',
                    command: () => {
                        history.push("/referralsettings");
                    }
                },
                { className: location.pathname === '/rechargecommission' ? 'p-highlight': '',
                    label: language.recharge_commission,
                    icon: 'pi pi-fw pi-dollar',
                    command: () => {
                        history.push("/rechargecommission");
                    }
                },
                {
                    className: location.pathname === '/cartypes' ? 'p-highlight': '',
                    label: language.car_type,
                    icon: 'pi pi-fw pi-car',
                    command: () => {
                        history.push("/cartypes");
                    }
                },
                {
                    className: location.pathname === '/zones' ? 'p-highlight': '',
                    label: language.zone_text,
                    icon: 'pi pi-fw pi-map',
                    command: () => {
                        history.push("/zones");
                    }
                },
                {
                    className: location.pathname === '/subzones' ? 'p-highlight': '',
                    label: language.subzones,
                    icon: 'pi pi-fw pi-map',
                    command: () => {
                        history.push("/subzones");
                    }
                },
                {
                    className: location.pathname === '/crowdedzones' ? 'p-highlight': '',
                    label: language.crowded_zones,
                    icon: 'pi pi-fw pi-map',
                    command: () => {
                        history.push("/crowdedzones");
                    }
                },
                {
                    className: location.pathname === '/incrementhours' ? 'p-highlight': '',
                    label: language.increment_hours,
                    icon: 'pi pi-fw pi-clock',
                    command: () => {
                        history.push("/incrementhours");
                    }
                },
                {
                    className: location.pathname === '/cancelreasons' ? 'p-highlight': '',
                    label: language.cancellation_reasons,
                    icon: 'pi pi-fw pi-times',
                    command: () => {
                        history.push("/cancelreasons");
                    }
                },
                {
                    className: location.pathname === '/defaultfeedbacks' ? 'p-highlight': '',
                    label: language.default_feedbacks,
                    icon: 'pi pi-fw pi-star',
                    command: () => {
                        history.push("/defaultfeedbacks");
                    }
                },
                {
                    className: location.pathname === '/defaultchatmessages' ? 'p-highlight': '',
                    label: language.default_chat_messages,
                    icon: 'far fa-comment',
                    command: () => {
                        history.push("/defaultchatmessages");
                    }
                },
                {
                    className: location.pathname === '/appsliders' ? 'p-highlight': '',
                    label: language.app_slider,
                    icon: 'pi pi-fw pi-images',
                    command: () => {
                        history.push("/appsliders");
                    },
                },
                {
                    className: location.pathname === '/termsandprivacy' ? 'p-highlight': '',
                    label: language.terms_and_privacy,
                    icon: 'pi pi-fw pi-shield',
                    command: () => {
                        history.push("/termsandprivacy");
                    },
                },
            ]
        },
        {
            label: language.settings_title,
            icon: 'pi pi-fw pi-cog',
            expanded: isExpanded('settings'),
            items: [
                {
                    className: location.pathname === '/settings' ? 'p-highlight': '',
                    label: language.settings_title,
                    icon: 'pi pi-fw pi-cog',
                    command: () => {
                        history.push("/settings");
                    }
                },
                {
                    className: location.pathname === '/fleetadmins' ? 'p-highlight': '',
                    label: language.fleetadmins,
                    icon: 'pi pi-fw pi-users',
                    command: () => {
                        history.push("/fleetadmins");
                    }
                },
                {
                    className: location.pathname === '/dispatchers-work-schedule' ? 'p-highlight': '',
                    label: language.dispatcher_work_schedule,
                    icon: 'pi pi-fw pi-calendar',
                    command: () => {
                        history.push("/dispatchers-work-schedule");
                    }
                },
                {
                    className: location.pathname === '/profile' ? 'p-highlight': '',
                    label: language.profile,
                    icon: 'pi pi-fw pi-user',
                    command: () => {
                        history.push("/profile");
                    }
                },
            ]
        },
        {
            label: language.logout,
            icon: 'pi pi-pw pi-sign-out',
            command: () => {
                LogOut();
            },
        },
    ];

    const menuItemsFleetAdmin = [
        {
            label: language.dashboard_text,
            icon: 'pi pi-fw pi-home',
            command: () => {
                history.push("/dashboard-beta");
            },
        },
        {
            label: language.saved_addresses,
            icon: 'pi pi-fw pi-map-marker',
            command: () => {
                history.push("/saved-address");
            },
        },
        {
            label: language.booking_history,
            icon: 'pi pi-fw pi-book',
            command: () => {
                history.push("/bookingsadvance");
            },
        },
        {
            className: location.pathname === '/dispatchers-work-schedule' ? 'p-highlight': '',
            label: language.dispatcher_work_schedule,
            icon: 'pi pi-fw pi-calendar',
            command: () => {
                history.push("/dispatchers-work-schedule");
            }
        },
        {
            label: language.incident_reports,
            icon: 'pi pi-fw pi-info-circle',
            command: () => {
                history.push("/incidentreports");
            },
        },
        {
            label: language.appointment_booking,
            icon: 'pi pi-fw pi-calendar',
            command: () => {
                history.push("/appointmentbooking");
            },
        },
        {
            label: language.passengers_label,
            icon: 'pi pi-fw pi-users',
            items: [
                {
                    label: language.passengers_label,
                    icon: 'pi pi-fw pi-users',
                    command: () => {
                        history.push("/riders");
                    }
                },
                {
                    label: language.guest_booking_history,
                    icon: 'pi pi-fw pi-user',
                    command: () => {
                        history.push("/guestusers");
                    }
                },
            ]
        },
        {
            className: location.pathname === '/drivers' ? 'p-highlight': '',
            label: language.drivers,
            icon: 'pi pi-fw pi-users',
            command: () => {
                history.push("/drivers");
            }
        },
        {
            label: language.chat,
            icon: 'far fa-comments',
            command: () => {
                history.push("/chat");
            },
        },
        {
            label: language.settings_label2,
            icon: 'pi pi-fw pi-wallet',
            items: [
                {
                    label: language.wallet_history,
                    icon: 'pi pi-fw pi-dollar',
                    command: () => {
                        history.push("/wallethistory");
                    }
                },
            ]
        },
        {
            className: location.pathname === '/profile' ? 'p-highlight': '',
            label: language.profile,
            icon: 'pi pi-fw pi-user',
            command: () => {
                history.push("/profile");
            }
        },
        {
            label: language.logout,
            icon: 'pi pi-pw pi-sign-out',
            command: () => {
                LogOut();
            },
        },
    ];

    return (
        <div>
            <div style={{ display: 'flex', justifyContent: 'center', backgroundColor: '#00763F' }}>
                <img style={{ marginTop: '20px', marginBottom: '20px', width: '120px', height: '119px' }} src={assets.logo120x120} alt="Logo" />
            </div>
            <Divider />
            <PanelMenu
                model={isAdmin ? menuItems : menuItemsFleetAdmin}
                className="w-full"
            />
        </div>
    );
}

export default AppMenu;